import React, { useState, useEffect } from "react";
import Joyride from "react-joyride";
import "./Guided.css";

const Guided = () => {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const steps = [
    {
      target: ".highlight-1",
      content: "This is the first section!",
      placement: "top",
    },
    {
      target: ".highlight-2",
      content: "Now we are highlighting the second section.",
      placement: "top",
    },
    {
      target: ".highlight-3",
      content: "Finally, this is the third section.",
      placement: "top",
    },
    {
      target: ".highlight-4",
      content: "Finally, this is the Last section.",
      placement: "top",
    },
  ];

  const handleStartTour = () => {
    setRun(true);
    setStepIndex(0);
  };

  const handleJoyrideCallback = (data) => {
    const { status, action, index, type } = data;
  
    if (status === "finished" || status === "skipped") {
      setRun(false);
      removeHighlight();
      return;
    }
  
    if (type === "step:after") {
      removeHighlight();
  
      // Calculate next step index
      let nextIndex = index + (action === "next" ? 1 : -1);
  
      // Ensure nextIndex is within bounds
      if (nextIndex >= 0 && nextIndex < steps.length) {
        setStepIndex(nextIndex);
        highlightSection(steps[nextIndex].target);
      }
    }
  };
  
  

  // Function to add highlight effect
  const highlightSection = (selector) => {
    document.querySelector(selector)?.classList.add("joyride-highlight");
  };

  // Function to remove highlight effect
  const removeHighlight = () => {
    document.querySelectorAll(".joyride-highlight").forEach((el) => {
      el.classList.remove("joyride-highlight");
    });
  };

  useEffect(() => {
    return () => removeHighlight();
  }, []);

  return (
    <div>
      <button onClick={handleStartTour} className="btn btn-primary btn-me start-tour-btn">
        Start Guided Tour
      </button>

      <Joyride
        steps={steps}
        run={run}
        stepIndex={stepIndex}
        callback={handleJoyrideCallback}
        continuous
        showProgress
        showSkipButton
        disableOverlayClose
      />
    </div>
  );
};

export default Guided;
